/**
 * O caso que se cadastra sozinho (E189.F2, ADR-0138): o círculo, a etapa da leitura e, enquanto os
 * documentos são lidos, quantos já foram. A pessoa não precisa ficar aqui: volta aos casos ou cadastra
 * o próximo, e o caso aparece em "Cadastros em andamento" até o sistema concluir.
 */
import { Button, Spinner } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import type { AndamentoDoCadastroData, EtapaDoCadastro } from '@/lib/cadastro_sem_espera';

import { BOTAO_DO_RODAPE, RODAPE_DA_JORNADA } from './PecasDaAbertura';

const t = ptBR.abertura.cadastro;

/** A etapa com a contagem dos documentos, só enquanto eles são lidos. */
export function rotuloDaEtapa(andamento: AndamentoDoCadastroData): string {
  const etapa: EtapaDoCadastro = andamento.etapa ?? 'concluindo';
  const rotulo = t.etapa[etapa];
  if (etapa !== 'lendo_documentos' || andamento.documentos === 0) return rotulo;
  const contagem = t.contagem
    .replace('{lidos}', String(andamento.documentos_lidos))
    .replace('{total}', String(andamento.documentos));
  return `${rotulo} · ${contagem}`;
}

export function CadastrandoOCaso({
  andamento,
  onVoltarAosCasos,
  onNovoCaso,
}: {
  andamento: AndamentoDoCadastroData;
  onVoltarAosCasos: () => void;
  onNovoCaso: () => void;
}): JSX.Element {
  return (
    <div className="flex flex-col gap-5" data-testid="abertura-cadastrando">
      <div
        role="status"
        aria-live="polite"
        className="flex items-start gap-3 border border-border bg-surface-2 px-4 py-4"
      >
        <Spinner className="mt-[3px]" />
        <div className="flex flex-col gap-1">
          <p className="font-display text-[16px] font-semibold text-fg">{t.titulo}</p>
          <p className="text-corpo text-fg" data-testid="abertura-cadastrando-etapa">
            {rotuloDaEtapa(andamento)}
          </p>
          <p className="text-body-sm text-fg-muted">{t.texto}</p>
        </div>
      </div>
      <div className={RODAPE_DA_JORNADA}>
        <Button
          type="button"
          variant="secondary"
          className={BOTAO_DO_RODAPE}
          data-testid="abertura-cadastrando-voltar"
          onClick={onVoltarAosCasos}
        >
          {ptBR.abertura.voltarAosCasos}
        </Button>
        <Button
          type="button"
          className={BOTAO_DO_RODAPE}
          data-testid="abertura-cadastrando-novo"
          onClick={onNovoCaso}
        >
          {t.novoCaso}
        </Button>
      </div>
    </div>
  );
}
